import React from 'react';

export default function EmptyState({ title = 'Nada por aqui ainda', description, icon: Icon, action, testid }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid={testid}>
      {Icon && (
        <div className="w-14 h-14 rounded-md border border-zinc-800 bg-zinc-900/60 flex items-center justify-center mb-4">
          <Icon size={22} className="text-zinc-600" />
        </div>
      )}
      <div className="font-display text-base font-medium text-zinc-200">{title}</div>
      {description && <div className="text-[13px] text-zinc-500 mt-1.5 max-w-md">{description}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
